<template>
  <div v-if="is_valid_brick" class="d-flex flex-row flex-wrap">
    <div class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('TRAIN_DIMENSIONS')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-primary"
        />
        <text-fitter
          :value="train_file_dimensions"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>

    <div v-if="train_poid !== eval_poid" class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('EVAL_DIMENSIONS')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-success"
        />
        <text-fitter
          :value="eval_file_dimensions"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "TRAIN_DIMENSIONS": "TRAIN DIMENSIONS",
    "EVAL_DIMENSIONS": "EVAL DIMENSIONS"
  },
  "fr": {
    "TRAIN_DIMENSIONS": "DIMENSIONS ENTRAINEMENT",
    "EVAL_DIMENSIONS": "DIMENSIONS EVALUATION"
  }
}
</i18n>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import numeral from 'numeral'

import { extended_dict_getValue } from '@/utils.js'
import { get_columnstore_general_metadata } from '@/api/subscriptions.js'
import { FrozenDict } from './object_model.js'

import { subscription_mixin, summary_mixin } from '@/components/mixin.js'
import TextFitter from './text_fitter.vue'

// *****************************************************************************

export default {
  name: 'SummaryDefault',
  components: { TextFitter },
  mixins: [subscription_mixin, summary_mixin],
  props: ['project_id', 'brick_id'],
  data() {
    return {
      train_nb_rows: undefined,
      train_nb_columns: undefined,
      eval_nb_rows: undefined,
      eval_nb_columns: undefined,
    }
  },
  computed: {
    train_poid() {
      const metavar = new FrozenDict()
      metavar.setValue('is_training', true)

      let dict = this.cur_brick.last_poids_build_cache
      let poid = extended_dict_getValue(dict, metavar)
      if (_.isUndefined(poid)) {
        poid = -1
      }
      return poid
    },
    eval_poid() {
      const metavar = new FrozenDict()
      metavar.setValue('is_training', false)

      let dict = this.cur_brick.last_poids_build_cache
      let poid = extended_dict_getValue(dict, metavar)
      if (_.isUndefined(poid)) {
        poid = -1
      }
      return poid
    },
    train_poid_instantiated() {
      return this.fetch_poid_status('train_poid_status', this.train_poid)
    },
    eval_poid_instantiated() {
      return this.fetch_poid_status('eval_poid_status', this.eval_poid)
    },
    train_file_dimensions() {
      let res = this.$t('currently_computing')
      if (
        !(
          _.isUndefined(this.train_nb_rows) ||
          _.isUndefined(this.train_nb_columns)
        )
      ) {
        res = this.train_nb_rows + 'L x ' + this.train_nb_columns + 'C'
      }
      return res
    },
    eval_file_dimensions() {
      let res = this.$t('currently_computing')
      if (
        !(
          _.isUndefined(this.eval_nb_rows) ||
          _.isUndefined(this.eval_nb_columns)
        )
      ) {
        res = this.eval_nb_rows + 'L x ' + this.eval_nb_columns + 'C'
      }
      return res
    },
  },
  watch: {
    train_poid_instantiated: {
      immediate: true,
      async handler(new_val) {
        if (new_val) {
          let res = await get_columnstore_general_metadata(
            this.project_id,
            this.train_poid
          )
          this.train_nb_columns = (res.pipe_object || {}).nb_cols
          this.train_nb_rows = (res.pipe_object || {}).nb_rows
        }
      },
    },
    eval_poid_instantiated: {
      immediate: true,
      async handler(new_val) {
        if (new_val) {
          if (this.eval_poid != this.train_poid) {
            let res = await get_columnstore_general_metadata(
              this.project_id,
              this.eval_poid
            )
            this.eval_nb_columns = (res.pipe_object || {}).nb_cols
            this.eval_nb_rows = (res.pipe_object || {}).nb_rows
          }
        }
      },
    },
  },
}
</script>
